import { User, UserRole } from '../models/user.model';

/**
 * Validate if the user has the specified role
 * @param user {User}
 * @param role {UserRole}
 * @returns true or false
 */
export enum BrokerUserRole {
  USBroker = 'US Broker',
  InvestorBroker = 'Investor Broker',
  OccupierBroker = 'Occupier Broker',
}

export const hasUserRole = (user: User, role: UserRole): boolean => {
  if (role == null) {
    return false;
  }
  return user?.roleId === role;
};

/**
 * Valdate if the user has one of the specified roles
 * @param user {IUser}
 * @param roleList {UserRole[]}
 * @returns true or false
 */
export const hasOneOfTheRoles = (user: User, roleList: UserRole[]): boolean => {
  if (roleList == null) {
    return false;
  }
  return roleList?.includes(user?.roleId);
};

export function isBrokerRole(role: BrokerUserRole): boolean {
  return [BrokerUserRole.USBroker, BrokerUserRole.InvestorBroker, BrokerUserRole.OccupierBroker].includes(role);
}
export function getUserRole(): BrokerUserRole {
  const userInfo = localStorage.getItem('userInfo');
  if (userInfo) {
    const { roleVal } = JSON.parse(userInfo);
    return roleVal as BrokerUserRole;
  }
  return null;
}
